<template>
    <Container class="tw-items-center tw-justify-center">
        <v-img
            aspect-ratio="1"
            class="tw-size-32 tw-max-h-32 tw-max-w-32 sm:tw-size-48 sm:tw-max-h-48 sm:tw-max-w-48"
            src="@/assets/images/newsletter/image.png"></v-img>
        <h1 class="tw-max-w-48 tw-text-center tw-text-2xl sm:tw-text-3xl sm:tw-max-w-60 tw-font-bold tw-font-title">
            {{ $t('Newsletter.title.part1') }}
            <br />{{ $t('Newsletter.title.part2') }}<span class="tw-text-primary">{{ $t('Newsletter.title.part3') }}</span
            >{{ $t('Newsletter.title.part4') }}
        </h1>
        <p class="tw-mt-4 tw-max-w-44 tw-text-center tw-text-xs sm:tw-text-base sm:tw-max-w-60">Não perca o melhor da semana! Clique em 'Subscrever' e receba os conteúdos mais relevantes do 24Horas no seu email.</p>
        <v-form
            ref="form"
            class="tw-mt-16 tw-w-full tw-max-w-64 sm:tw-max-w-80 tw-text-center"
            @submit.prevent="subscribe">
            <v-text-field
                v-model="email"
                base-color="gray-300"
                class="tw-mt-4 tw-text-xs sm:tw-text-sm"
                color="red"
                name="email"
                placeholder="Insira o seu email"
                required
                :rules="[rules.required, rules.email]"
                type="email"
                variant="outlined">
            </v-text-field>
            <Button
                class="tw-mt-4 sm:tw-mt-6"
                type="submit">
                {{ $t('Newsletter.subscribe') }}
            </Button>
        </v-form>
    </Container>
</template>

<script setup lang="ts">
    import useRules from '@/composables/rules';
    import type { VForm } from 'vuetify/components';

    const rules = useRules();

    const form = ref<InstanceType<typeof VForm> | null>(null);
    const email = ref<string>('');

    async function subscribe() {
        if (!form.value) {
            return;
        }

        const { valid } = await form.value.validate();

        if (!valid) {
            return;
        }
    }
</script>

<style scoped></style>
